<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
  >
    <rect
      id="사각형_3731"
      data-name="사각형 3731"
      fill="#1c7346"
      width="18"
      height="18"
      transform="translate(0 0)"
    />
    <g id="그룹_3751" data-name="그룹 3751" transform="translate(5.898 5.347)">
      <path
        id="패스_1816"
        data-name="패스 1816"
        fill="#fff"
        d="M-2390.731,4714.956l-1.891-3.538h1.95l.588,1.3c.157.343.323.725.529,1.2h.039c.167-.47.323-.853.47-1.2l.529-1.3h1.853l-1.882,3.616,2.009,3.675h-1.95l-.676-1.421c-.176-.382-.343-.764-.539-1.215h-.039c-.177.451-.333.833-.5,1.215l-.627,1.421h-1.872Z"
        transform="translate(2392.74 -4711.418)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 18,
    },
  },
};
</script>
